import polyfills from './polyfills';
import jquery from 'jquery'
import AjaxForm from './ajax-form'
import Modal from './modal'

window.$ = jquery;


// WEBPACK FOOTER //
// ./resources/js/frontend/core.js